var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"main-navigation",class:{
    'main-navigation--busy': _vm.isBusy,
    'main-navigation--open': _vm.hasVisibleLabels,
  }},[_c('ul',{staticClass:"main-navigation__items"},[_c('li',{staticClass:"main-navigation__item"},[_c('PLink',{staticClass:"main-navigation__link",on:{"clicked":_vm.logout}},[_c('IdfIcon',{staticClass:"main-navigation__link-icon",attrs:{"kind":'profile-outlined'}}),_c('span',{staticClass:"main-navigation__link-label"},[_vm._v("Déconnexion")])],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }